/**
 * Menvora — nota COD estilo carrito.
 * Se inserta DENTRO de label.rsi-shipping-rates-item (caja con borde + radio),
 * sin ocultar ni quitar el radio de Releasit.
 */
(function () {
  if (window.__menvoraCodShippingNote) return;
  window.__menvoraCodShippingNote = true;

  var attempts = 0;
  var MAX = 16;
  var timer = 0;

  function cloneNote() {
    var tpl = document.getElementById('menvora-cod-shipping-note-tpl');
    if (!tpl || !tpl.content) return null;
    return tpl.content.firstElementChild.cloneNode(true);
  }

  /** Caja con borde: label.rsi-shipping-rates-item */
  function findShippingItem(wrap) {
    if (!wrap) return null;
    var item =
      wrap.querySelector('label.rsi-shipping-rates-item') ||
      wrap.querySelector('.rsi-shipping-rates-item');
    if (item) return item;

    var radio =
      wrap.querySelector('input.rsi-shipping-rates-radio[name="shippingRate"]') ||
      wrap.querySelector('input[name="shippingRate"][type="radio"]');
    if (radio) {
      return radio.closest('label.rsi-shipping-rates-item') || radio.closest('label') || radio.parentElement;
    }
    return null;
  }

  function ensureChecked(item) {
    var radio =
      (item && item.querySelector('input.rsi-shipping-rates-radio, input[name="shippingRate"]')) ||
      null;
    if (!radio) return;
    if (radio.checked) return;
    try {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    } catch (e) { /* noop */ }
  }

  function placeNote(item, note) {
    if (!item || !note) return;

    var wrap = document.getElementById('rsi_form_wrapper');
    if (wrap) {
      // Quitar mounts fuera de este label
      wrap.querySelectorAll('[data-menvora-cod-shipping-note]').forEach(function (el) {
        if (el !== note && !item.contains(el)) el.remove();
      });
      // Restaurar UI si un mount viejo la había ocultado
      wrap.querySelectorAll('[data-menvora-shipping-ui-hidden]').forEach(function (el) {
        el.removeAttribute('data-menvora-shipping-ui-hidden');
        el.style.display = '';
        el.removeAttribute('aria-hidden');
      });
    }

    item.setAttribute('data-menvora-shipping-note-host', '1');

    // Insertar DESPUÉS del contenido del radio (Envío gratis arriba, nota abajo)
    if (note.parentElement !== item) {
      item.appendChild(note);
    } else if (item.lastElementChild !== note) {
      item.appendChild(note);
    }
  }

  function mount() {
    var wrap = document.getElementById('rsi_form_wrapper');
    if (!wrap) {
      attempts = 0;
      return false;
    }

    var item = findShippingItem(wrap);
    if (!item) return false;

    ensureChecked(item);

    var existing = item.querySelector(':scope > [data-menvora-cod-shipping-note], [data-menvora-cod-shipping-note]');
    if (existing && item.contains(existing)) {
      placeNote(item, existing);
      return true;
    }

    var orphan = wrap.querySelector('[data-menvora-cod-shipping-note]');
    if (orphan) {
      placeNote(item, orphan);
      return true;
    }

    if (attempts >= MAX) return false;
    attempts += 1;

    var node = cloneNote();
    if (!node) return false;

    try {
      placeNote(item, node);
    } catch (e) {
      return false;
    }
    return true;
  }

  function watch() {
    if (timer) return;
    timer = window.setInterval(function () {
      var wrap = document.getElementById('rsi_form_wrapper');
      if (!wrap) {
        attempts = 0;
        return;
      }
      var visible =
        wrap.getBoundingClientRect().height > 40 &&
        window.getComputedStyle(wrap).display !== 'none';
      if (!visible) return;
      mount();
    }, 500);
  }

  function init() {
    if (!document.getElementById('menvora-cod-shipping-note-tpl')) return;
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
